import React, { createContext, useContext, useEffect, useState } from "react";
import { postRequest } from "../../utils/api/requests/request";
import { FEATURE_TOGGLES_STORAGE_KEY } from "../../utils/helper/feature-toggle";

// Create the context
const FeatureContext = createContext(null);

// Custom hook for accessing data context
export const useFeatures = () => {
  return useContext(FeatureContext);
};

// Provider component
export const FeatureProvider = ({ children }) => {
  const [features, setFeatures] = useState(null);
  const [enabledFeaturesFromCache] = useState(
    JSON.parse(localStorage.getItem(FEATURE_TOGGLES_STORAGE_KEY))?.value
  );

  // console.log("enabledFeaturesFromCache  --- ", enabledFeaturesFromCache);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await postRequest("GetPlatformFeatureTogglesQuery"); // Replace with your API
        // console.log("response  --- ", response);
        if (response?.outData && response?.outData.isSuccessful) {
          setFeatures(response?.outData?.data);
        }
      } catch (err) {
        setError(err?.message);
      } finally {
        setLoading(false);
      }
    };
    if (!loading && !features) {
      fetchData();
    }
  }, []); // Run only on initial render

  const findFeature = (featureValue) =>
    features?.find((f) => f.id === featureValue)?.isEnabled ?? false;

  const hasFeature = (featureCode) => {
    // return true;
    if (!Array.isArray(enabledFeaturesFromCache) || !featureCode) return false;
    const match = enabledFeaturesFromCache.find(
      (f) => f?.featureCode === featureCode
    );
    // Check if the feature exists and is enabled
    if (!match) return false;
    // Return the boolean value of isEnabled
    return Boolean(match.isEnabled);
  };

  // Return the provider with value
  return (
    <FeatureContext.Provider
      value={{
        features,
        findFeature,
        loading,
        error,
        hasFeature,
      }}
    >
      {children}
    </FeatureContext.Provider>
  );
};
